import { environment } from '../../../environments/environment';

/**
 * URL pintable del avatar de una cuenta (N11 de B10). La API guarda en `users.avatar` solo el NOMBRE del
 * fichero, que vive en `public/images/users/` del backend; usarlo tal cual como `src` daba una imagen rota.
 * Una URL absoluta (`http(s)://`) se respeta por si algún día llega resuelta. Vacío → `null`: quien pinta
 * decide el sustituto (icono o mascota).
 */
export function userAvatarUrl(avatar: string | null | undefined): string | null {
  const value = avatar?.trim();
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;
  // `environment.imagesUrl` ya termina en `/images/`.
  return `${environment.imagesUrl}users/${value}`;
}
